"use client";
import type React from "react";
import { cn } from "../lib/utils";

type AnimatedLoadingSpinnerProps = {
  className?: string;
  /**
   * Time for one eighth of a turn. Kept for API compatibility: a full turn
   * takes eight segments, so the default of 125ms is one turn per second.
   */
  segmentTimeInMS?: number;
  size?: number;
};

/**
 * Teral's spinner: a faint track with a bright arc that sweeps around it while
 * its length breathes. Drawn with strokes so it inherits `currentColor` and
 * stays crisp at any size.
 */
export const AnimatedLoadingSpinner = ({
  className,
  segmentTimeInMS = 125,
  size = 18,
}: AnimatedLoadingSpinnerProps) => {
  const turn = `${segmentTimeInMS * 8}ms`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      aria-hidden="true"
      className={cn("motion-safe:[animation:teral-spin_var(--turn)_linear_infinite]", className)}
      style={{ "--turn": turn } as React.CSSProperties}
    >
      <circle cx="9" cy="9" r="6.75" stroke="currentColor" strokeWidth="1.75" opacity="0.18" />
      <circle
        cx="9"
        cy="9"
        r="6.75"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        pathLength={100}
        strokeDasharray="28 100"
        className="motion-safe:[animation:teral-spinner-arc_1.6s_ease-in-out_infinite]"
      />
    </svg>
  );
};
